import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCVEDetails,
  fetchCVEDetailsGraph,
  fetchCVEDetailsTotal,
  fetchCVEDetailsAction,
} from "../../actions/vulnerability";
import { fetchCustomerDomains } from "../../actions/customer";
// import { Link  , useParams} from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import BasicLineColumn from "../common/apexChart/lineChart";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Donut } from "react-dial-knob";
import GaugeChart from "react-gauge-chart";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import KnownsubscribersChart from "../common/dashboard9/knownsubscribersChart";
import { API_URL } from "../../utils/constant";

const KnownVulnerability = () => {
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [search, setsearch] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [ipFilter, setIpFilter] = useState("");
  const [cveIdFilter, setCveIdFilter] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [limit, setLimit] = useState(10);
  const [domain, setDomain] = useState("");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const { orgId } = useParams();
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  }); const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  let table = useSelector(
    (state) => state.vulnerability?.cveDetails?.data?.data
  );

  let totalCount = useSelector((state) => state.vulnerability?.cveTotal?.data);

  const pagination = useSelector(
    (state) => state.vulnerability?.cveDetails?.data
  );

  let scanCompleted = useSelector(
    (state) => state.vulnerability?.scanCompleted
  );
  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };

  const scanDetails = useSelector(
    (state) => state?.vulnerability?.cveGraph?.data
  );

  const auth = useSelector((state) => state?.auth?.user);

  const iPDetails = useSelector(
    (state) => state?.vulnerability?.cveDetails?.scanDetailArray?.ipDetails
  );

  const customerDomains = useSelector(
    (state) => state?.customer?.customerDomains?.data || []
  );

  const [selectedVulnerability, setSelectedVulnerability] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  // Add state for expandable rows
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [expandedRemedies, setExpandedRemedies] = useState(new Set());

  const toggleDescription = (index) => {
    const newExpandedRows = new Set(expandedRows);
    if (newExpandedRows.has(index)) {
      newExpandedRows.delete(index);
    } else {
      newExpandedRows.add(index);
    }
    setExpandedRows(newExpandedRows);
  };

  const toggleRemedy = (index) => {
    const newExpandedRemedies = new Set(expandedRemedies);
    if (newExpandedRemedies.has(index)) {
      newExpandedRemedies.delete(index);
    } else {
      newExpandedRemedies.add(index);
    }
    setExpandedRemedies(newExpandedRemedies);
  };

  useEffect(() => {
    if (orgId) {
      fetchCVEDetails(orgId, dispatch, page, PageSize, search, category, ipFilter, limit, cveIdFilter);
    } else {
      fetchCVEDetails(id, dispatch, page, PageSize, search, category, ipFilter, limit, cveIdFilter);
    }
  }, [id, dispatch, page, PageSize, search, category, ipFilter, cveIdFilter, limit]);

  useEffect(() => {
    setTotalItems(pagination?.cveDetailsRecord);
  }, [pagination?.cveDetailsRecord]);

  useEffect(() => {
    fetchCVEDetailsTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchCVEDetailsGraph(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    // Fetch domains for the current client/organization
    if (id) {
      dispatch(fetchCustomerDomains(id));
    }
  }, [id, dispatch]);

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event == "markAsRemidiated") {
      let ids = [];
      ids.push(_id);
      const data = {
        action: "markAsRemidiated",
        pvaIds: selectedIds == 0 ? ids : selectedIds,
        actionNote: "",
        for: "forever",
      };
      fetchCVEDetailsAction(
        id,
        dispatch,
        page,
        limit,
        search,
        category,
        ipFilter,
        data,
        cveIdFilter
      );
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
      setPage(1);
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      pvaIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchCVEDetailsAction(id, dispatch, page, limit, search, category, ipFilter, data, cveIdFilter);
    setSelectedIds([]);
    setPage(1);
  };

  const submit = () => {
    const data = {
      action: action,
      pvaIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchCVEDetailsAction(id, dispatch, page, limit, search, category, ipFilter, data, cveIdFilter);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
    setPage(1);
  };

  let ipArray = [];
  for (let details = 0; details < scanDetails?.scanDetails?.length; details++) {
    ipArray.push(scanDetails?.scanDetails?.[details]?.length || 0);
  }

  let mapData = table;

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/cve-details/${id}/excel`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')} IP Vulnerability Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const severity = (val) => {
    if (val < 4) {
      return "Low";
    }
    if (val >= 4 && val < 7) {
      return "Medium";
    }
    if (val >= 7 && val < 9) {
      return "High";
    }
    if (val >= 9) {
      return "Critical";
    }
  };

  const severityBatch = (val) => {
    if (val < 4) {
      return "badge badge-low";
    }
    if (val >= 4 && val < 7) {
      return "badge badge-med";
    }
    if (val >= 7 && val < 9) {
      return "badge badge-high";
    }
    if (val >= 9) {
      return "badge badge-critical";
    }
  };

  const openDetailsModal = (vulnerability) => {
    setSelectedVulnerability(vulnerability);
    setShowDetailsModal(true);
  };

  const closeDetailsModal = () => {
    setSelectedVulnerability(null);
    setShowDetailsModal(false);
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Passive Vulnerability Assessment</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li className="breadcrumb-item active" aria-current="page">
                    Passive Vulnerability Assessment
                  </li>
                </ol>
                <br />
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
              {mapData?.length === 0 ? null : (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <div className="row clearfix">
          <div className="col-lg-12 col-md-8">
            <div className="row">
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("critical");
                      setsearch("critical");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.totalCriticalVulnerabilities || 0}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#CA1D1D",
                          // centerColor: "transparent",
                          bgrColor: "#CA1D1D33"
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      {/* <h4 className="mb-0">34.80%</h4> */}
                      <h4 className="mb-0">Critical</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("high");
                      setsearch("high");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.totalHighVulnerabilities || 0}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#EE4B2B",
                          // centerColor: "transparent",
                          bgrColor: "#EE4B2B33"
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      <h4 className="mb-0">High</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("medium");
                      setsearch("medium");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.totalMediumVulnerabilities || 0}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#FF8C00",
                          // centerColor: "#FF8C00",
                          bgrColor: "#FF8C0033"
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      <h4 className="mb-0">Medium</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("low");
                      setsearch("low");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.totalLowVulnerabilities || 0}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#48B461",
                          // centerColor: "transparent",
                          bgrColor: "#48B46133"
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      <h4 className="mb-0">Low</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
            <div className="card">
              <div className="body">
                <div className="header">
                  <h6 className="welcome-textSmall">Previous scan details</h6>
                </div>
                {scanDetails?.scanDetails &&
                  scanDetails?.scanDetails?.filter(detail => detail !== null)?.length > 0 && (
                    <KnownsubscribersChart
                      dates={scanDetails?.dates}
                      data={scanDetails?.scanDetails}
                    />
                  )}
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12">
            <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
              <li className="nav-item">
                <a
                  className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("all");
                    setPage(1);
                    setsearch("all");
                    setfilterData("all");
                    setIpFilter("");
                    setCveIdFilter("");
                    setSelectedIds([]);
                  }}
                >
                  Current
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("risk-accepted");
                    setPage(1);
                    setsearch("all");
                    setfilterData("all");
                    setIpFilter("");
                    setCveIdFilter("");
                    setSelectedIds([]);
                  }}
                >
                  Risk Accepted
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("false-positive");
                    setPage(1);
                    setfilterData("all");
                    setsearch("all");
                    setIpFilter("");
                    setCveIdFilter("");
                    setSelectedIds([]);
                  }}
                >
                  False Positive
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                    }`}
                  onClick={() => {
                    setCategory("remidiated");
                    setPage(1);
                    setfilterData("all");
                    setsearch("all");
                    setIpFilter("");
                    setCveIdFilter("");
                    setSelectedIds([]);
                  }}
                >
                  Remediated
                </a>
              </li>
            </ul>
            <div className="card card_tableBox">
              <div className="body">
                <div className="header" ref={myRef}>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6>Vulnerability Details</h6>
                        <div className="filterBox d-flex">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm mr-2"
                            value={filterData}
                            onChange={(e) => {
                              setsearch(e.target.value);
                              setfilterData(e.target.value);
                              setPage(1);
                            }}
                          >
                            <option value="all">Select Severity</option>
                            <option value="critical">Critical</option>
                            <option value="high">High</option>
                            <option value="medium">Medium</option>
                            <option value="low">Low</option>
                          </select>
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm mb-2"
                            placeholder="Select Domain"
                            value={domain}
                            onChange={(e) => {
                              setDomain(e.target.value);
                              setPage(1);
                            }}
                          >
                            <option value="">All Domains</option>
                            {customerDomains?.domains?.map((domainItem, index) => (
                              <option key={index} value={domainItem}>
                                {domainItem}
                              </option>
                            ))}
                          </select>
                          <input
                            type="text"
                            className="form-control form-control-sm mr-2"
                            value={ipFilter}
                            onChange={(e) => setIpFilter(e.target.value)}
                            placeholder="IP Address"
                            style={{ minWidth: "150px" }}
                          />
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={cveIdFilter}
                            onChange={(e) => setCveIdFilter(e.target.value)}
                            placeholder="CVE ID"
                            style={{ minWidth: "150px" }}
                          />
                          
                        </div>
                      </div>

                    </div>
                    <div className="col-sm-2">
                      {selectedIds.length > 1 && userPermission && category === "all" && (
                        <Box sx={{ width: 160 }}>
                          <FormControl fullWidth>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={selectedValue}
                              onChange={(event) => {
                                setAction(event.target.value);
                                snooze("", event.target.value);
                              }}
                            >
                              <MenuItem value="pleaseSelect">
                                Snooze Options
                              </MenuItem>
                              <MenuItem
                                value="riskAccepted"
                                onClick={() => {
                                  addModal();
                                }}
                              >
                                Risk Accepted
                              </MenuItem>
                              <MenuItem
                                value="markAsFalsePositive"
                                onClick={() => {
                                  addModal();
                                }}
                              >
                                False Positive
                              </MenuItem>
                              <MenuItem value="markAsRemidiated">
                                Remediated
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      )}
                      {selectedIds.length > 1 &&
                        (category == "false-positive" ||
                          category == "risk-accepted") && (
                          <button
                            className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                            onClick={() => Unsnoozed("")}
                          >
                            Unsnooze
                          </button>
                        )}
                    </div>
                    <div className="col-lg-12">
                      <div className="table-responsive invoice_list mb-4">
                        <table className="table table-custom spacing5 mb-0">
                          <thead>
                            <tr>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th>
                                    <input
                                      type="checkbox"
                                      checked={
                                        selectedIds == 0 ? false : multiCheckTrue
                                      }
                                      onClick={() => {
                                        multicheck(currentTableData);
                                      }}
                                      className="checkUncheck"
                                    />
                                  </th>
                                )}
                              <th>IP Address</th>
                              <th>CVE Name</th>
                              <th>Severity</th>
                              <th>Ageing</th>
                              <th>Description</th>
                              <th>Remediation</th>
                              <th>Exploit</th>
                              <th>Details</th>
                              {category !== "all" && <th>Action Note</th>}
                              <th>Created At</th>
                              <th>Updated At</th>
                              {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th style={{ width: "80" }}>Action</th>
                                )}
                              {/* <th style={{ width: "500px" }}>Solutions</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {currentTableData?.map((row, index) => {
                              const isDescriptionExpanded = expandedRows.has(index);
                              const isRemedyExpanded = expandedRemedies.has(index);
                              return (
                                <React.Fragment key={row?._id}>
                                  <tr>
                                    {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                      category === "risk-accepted" ||
                                      category === "false-positive") && (
                                        <td>
                                          <input
                                            onClick={() => singleClick(row?._id)}
                                            checked={selectedIds?.includes(
                                              row?._id
                                            )}
                                            type="checkbox"
                                            className="checkUncheck"
                                          />
                                        </td>
                                      )}
                                    <td style={{ whiteSpace: "unset" }}>
                                      {row?.ip}
                                    </td>
                                    <td style={{ whiteSpace: "unset" }}>
                                      {row?.cveId}
                                    </td>
                                    <td style={{ whiteSpace: "unset" }}>
                                      <span
                                        className={
                                          row?.severity === "medium"
                                            ? "badge badge-med"
                                            : row?.severity === "low"
                                              ? "badge badge-low"
                                              : row?.severity === "high"
                                                ? "badge badge-high"
                                                : row?.severity === "critical"
                                                  ? "badge badge-critical"
                                                  : "N/A"
                                        }
                                      >
                                        {row?.severity}
                                      </span>
                                    </td>
                                    <td style={{ whiteSpace: "unset" }}>
                                      {moment().diff(
                                        moment(row?.cvePublishedAt),
                                        "days"
                                      )}{" "}
                                      days
                                    </td>
                                    <td style={{
                                      maxWidth: "400px",
                                      wordWrap: "break-word",
                                      lineHeight: "1.5",
                                      padding: "12px 16px"
                                    }}>
                                      {row?.description ? (
                                        <div style={{
                                          backgroundColor: expandedRows.has(index) ? '#f8f9fa' : 'transparent',
                                          padding: expandedRows.has(index) ? '12px' : '0',
                                          borderRadius: expandedRows.has(index) ? '8px' : '0',
                                          border: expandedRows.has(index) ? '1px solid #e9ecef' : 'none',
                                          transition: 'all 0.3s ease',
                                          width: '100%',
                                          overflow: 'hidden'
                                        }}>
                                          <div style={{
                                            fontSize: '14px',
                                            color: '#495057',
                                            marginBottom: expandedRows.has(index) ? '8px' : '0',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            whiteSpace: expandedRows.has(index) ? 'normal' : 'nowrap',
                                            ...(expandedRows.has(index) ? {
                                              whiteSpace: 'pre-wrap',
                                              wordBreak: 'break-word'
                                            } : {
                                              display: '-webkit-box',
                                              WebkitLineClamp: 5,
                                              WebkitBoxOrient: 'vertical',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              lineHeight: '1.4',
                                              maxHeight: 'calc(1.4em * 5)'
                                            })
                                          }}>
                                            {row.description}
                                          </div>
                                          <span
                                            className="text-primary"
                                            style={{
                                              cursor: 'pointer',
                                              fontSize: '13px',
                                              fontWeight: '500',
                                              textDecoration: 'none',
                                              padding: '4px 8px',
                                              borderRadius: '4px',
                                              backgroundColor: '#e3f2fd',
                                              color: '#1976d2',
                                              transition: 'all 0.2s ease',
                                              display: 'inline-block',
                                              marginTop: '4px'
                                            }}
                                            onMouseEnter={(e) => {
                                              e.target.style.backgroundColor = '#bbdefb';
                                            }}
                                            onMouseLeave={(e) => {
                                              e.target.style.backgroundColor = '#e3f2fd';
                                            }}
                                            onClick={() => toggleDescription(index)}
                                          >
                                            {expandedRows.has(index) ? 'Show less' : 'Show more'}
                                          </span>
                                        </div>
                                      ) : (
                                        <span style={{
                                          color: '#6c757d',
                                          fontStyle: 'italic',
                                          fontSize: '14px'
                                        }}>
                                          N/A
                                        </span>
                                      )}
                                    </td>
                                    <td className="" style={{
                                      maxWidth: "300px",
                                      wordWrap: "break-word",
                                      lineHeight: "1.5",
                                      padding: "12px 16px"
                                    }}>
                                      {row?.remedy ? (
                                        <div style={{
                                          backgroundColor: expandedRemedies.has(index) ? '#f8f9fa' : 'transparent',
                                          padding: expandedRemedies.has(index) ? '12px' : '0',
                                          borderRadius: expandedRemedies.has(index) ? '8px' : '0',
                                          border: expandedRemedies.has(index) ? '1px solid #e9ecef' : 'none',
                                          transition: 'all 0.3s ease',
                                          width: '100%',
                                          overflow: 'hidden'
                                        }}>
                                          <div style={{
                                            fontSize: '14px',
                                            color: '#495057',
                                            marginBottom: expandedRemedies.has(index) ? '8px' : '0',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            whiteSpace: expandedRemedies.has(index) ? 'normal' : 'nowrap',
                                            ...(expandedRemedies.has(index) ? {
                                              whiteSpace: 'pre-wrap',
                                              wordBreak: 'break-word'
                                            } : {
                                              display: '-webkit-box',
                                              WebkitLineClamp: 5,
                                              WebkitBoxOrient: 'vertical',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              lineHeight: '1.4',
                                              maxHeight: 'calc(1.4em * 5)'
                                            })
                                          }}>
                                            {row.remedy}
                                          </div>
                                          <span
                                            className="text-primary"
                                            style={{
                                              cursor: 'pointer',
                                              fontSize: '13px',
                                              fontWeight: '500',
                                              textDecoration: 'none',
                                              padding: '4px 8px',
                                              borderRadius: '4px',
                                              backgroundColor: '#e3f2fd',
                                              color: '#1976d2',
                                              transition: 'all 0.2s ease',
                                              display: 'inline-block',
                                              marginTop: '4px'
                                            }}
                                            onMouseEnter={(e) => {
                                              e.target.style.backgroundColor = '#bbdefb';
                                            }}
                                            onMouseLeave={(e) => {
                                              e.target.style.backgroundColor = '#e3f2fd';
                                            }}
                                            onClick={() => toggleRemedy(index)}
                                          >
                                            {expandedRemedies.has(index) ? 'Show less' : 'Show more'}
                                          </span>
                                        </div>
                                      ) : (
                                        <span style={{
                                          color: '#6c757d',
                                          fontStyle: 'italic',
                                          fontSize: '14px'
                                        }}>
                                          N/A
                                        </span>
                                      )}
                                    </td>
                                    <td style={{ whiteSpace: "unset" }}>
                                      {row?.knownExploit ? "Yes" : "No"}
                                    </td>
                                    <td style={{ whiteSpace: "unset" }}>
                                      <Link
                                        onClick={(e) => {
                                          e.preventDefault();
                                          openDetailsModal(row);
                                        }}
                                      >
                                        Details
                                      </Link>
                                    </td>
                                    {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                                    <td style={{ whiteSpace: "unset" }}>{row?.createdAt ? moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss') : "N/A"}</td>
                                    <td style={{ whiteSpace: "unset" }}>{row?.updatedAt ? moment(row.updatedAt).format('YYYY-MM-DD HH:mm:ss') : "N/A"}</td>
                                    {row?.remediationPending == true ? (
                                      <td>Retest in progress</td>
                                    ) : (
                                      <>
                                        {auth?.accessLevel != "Threat Analyst" && category === "all" && userPermission && (
                                          <td>
                                            <Box sx={{ width: 160 }}>
                                              <FormControl fullWidth>
                                                <Select
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={selectedValue}
                                                  onChange={(event) => {
                                                    setAction(event.target.value);
                                                    snooze(
                                                      row?._id,
                                                      event.target.value
                                                    );
                                                  }}
                                                >
                                                  <MenuItem value="pleaseSelect">
                                                    Snooze Options
                                                  </MenuItem>
                                                  <MenuItem
                                                    value="riskAccepted"
                                                    onClick={() => {
                                                      addModal();
                                                      setLookalikeAppId([row._id]);
                                                    }}
                                                  >
                                                    Risk Accepted
                                                  </MenuItem>
                                                  <MenuItem
                                                    value="markAsFalsePositive"
                                                    onClick={() => {
                                                      addModal();
                                                      setLookalikeAppId([row._id]);
                                                    }}
                                                  >
                                                    False Positive
                                                  </MenuItem>
                                                  <MenuItem value="markAsRemidiated">
                                                    Remediated
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                            </Box>
                                          </td>
                                        )}
                                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                                          category === "false-positive") && (
                                            <td>
                                              <button
                                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                                onClick={() => Unsnoozed(row?._id)}
                                              >
                                                Unsnooze
                                              </button>
                                            </td>
                                          )}
                                      </>
                                    )}
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-between align-content-center">
                        <div className="dataTables_paginate">
                          {totalItems > 0 && (
                            <Pagination
                              className="pagination-bar"
                              currentPage={page}
                              totalCount={totalItems}
                              pageSize={limit}
                              onPageChange={(page) => {
                                setPage(page);
                              }}
                            />
                          )}
                        </div>
                        {totalItems > 10 && (
                          <select
                            value={limit}
                            onChange={(e) => {
                              setLimit(e.target.value)
                            }}
                            className="form-control limitSelectBox"
                          >
                            <option value={10}>10 per page</option>
                            <option value={25}>25 per page</option>
                            <option value={50}>50 per page</option>
                            <option value={100}>100 per page</option>
                          </select>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row clearfix"></div>
            </div>
          </div>
        </div>
        <div className="row clearfix"></div>
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Details Modal */}
        <div
          className={`modal fade Form-Wizard-modal ${showDetailsModal ? "d-block show" : ""}`}
        >
          <div className="modal-dialog modal-lg" id="detailsModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="detailsModalLabel">
                  Vulnerability Details - {selectedVulnerability?.cveId}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeDetailsModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <div className="form-group ol-lg-12 col-md-12">
                          <h6 className="mb-3">Product Information</h6>
                          {selectedVulnerability?.productName && selectedVulnerability.productName.length > 0 ? (
                            <table className="table table-custom table-bordered spacing5 mb-4">
                              <thead>
                                <tr>
                                  <th>Product Name</th>
                                  <th>Type</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedVulnerability?.productName?.map((product, index) => (
                                  <tr key={index}>
                                    <td>{product.name}</td>
                                    <td>{product.type}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p>No product information available</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group ol-lg-12 col-md-12">
                          <h6 className="mb-3">Exploit Information</h6>
                          <div className="mb-3">
                            <strong>Known Exploit: </strong>
                            <span>{selectedVulnerability?.knownExploit ? "Yes" : "No"}</span>
                          </div>

                          {selectedVulnerability?.exploitUrl && selectedVulnerability.exploitUrl.length > 0 ? (
                            <table className="table table-custom table-bordered spacing5">
                              <thead>
                                <tr>
                                  <th>Exploit URL</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedVulnerability?.exploitUrl?.map((url, index) => (
                                  <tr key={index}>
                                    <td>
                                      <a href={url} target="_blank" rel="noopener noreferrer">
                                        {url}
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p>No exploit URLs available</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KnownVulnerability;
